<ng-container *clientScreen="let isDesktop = isDesktop">
	<div class="wrapper" [class.desktop]="isDesktop">
		<div class="modal" (click)="$event.stopPropagation()">
			<div class="fl-adaptable w-100 pos-rel ov-h">
				<div class="pos-abs pos-t-0 pos-l-0 w-100 h-100 carousel-wrapper">
					<ng-content></ng-content>
				</div>
			</div>

			<div class="w-100 fl-fixed fl fl-ai-c fl-jc-c">
				<ng-content select="[footer]"></ng-content>
			</div>

			<ng-content select="[insideModal]"></ng-content>
		</div>
	</div>
</ng-container>
